import EnterClassroomErrorModal from './EnterClassroomErrorModal';

export default EnterClassroomErrorModal;
